import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const routeLabels = {
  'geschenke': 'Geschenke',
  'eid-ul-fitr': 'Eid ul Fitr',
  'eid-ul-adha': 'Eid ul Adha',
  'ratgeber': 'Ratgeber',
  'ramadan': 'Ramadan',
  'ueber-uns': 'Über uns',
  'impressum': 'Impressum',
  'datenschutz': 'Datenschutz',
  'maenner': 'Männer',
  'frauen': 'Frauen',
  'kinder': 'Kinder',
  'familien': 'Familien',
};

export const Breadcrumbs = ({ items }) => {
  const location = useLocation();

  const crumbs = items || location.pathname
    .split('/')
    .filter(Boolean)
    .map((segment, index, arr) => ({
      label: routeLabels[segment] || segment.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' '),
      path: '/' + arr.slice(0, index + 1).join('/'),
    }));

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Startseite", "item": "https://eidgeschenke.de/" },
      ...crumbs.map((crumb, i) => ({
        "@type": "ListItem",
        "position": i + 2,
        "name": crumb.label,
        "item": `https://eidgeschenke.de${crumb.path}`
      }))
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <nav aria-label="Breadcrumb" className="py-3" data-testid="breadcrumbs">
        <ol className="flex items-center gap-1 text-sm text-[#6B7280] flex-wrap">
          <li>
            <Link to="/" className="hover:text-[#4A5D4F] transition-colors flex items-center gap-1">
              <Home className="w-3.5 h-3.5" />
              <span className="sr-only">Startseite</span>
            </Link>
          </li>
          {crumbs.map((crumb, index) => (
            <li key={crumb.path} className="flex items-center gap-1">
              <ChevronRight className="w-3.5 h-3.5 text-[#D1D5DB]" />
              {index === crumbs.length - 1 ? (
                <span className="text-[#2C332E] font-medium truncate max-w-[200px]">{crumb.label}</span>
              ) : (
                <Link to={crumb.path} className="hover:text-[#4A5D4F] transition-colors truncate max-w-[200px]">
                  {crumb.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};
